import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import LogRocket from 'logrocket';
import Cookies from 'js-cookie';
import { getFunctions } from 'firebase/functions';
import { getRemoteConfig } from 'firebase/remote-config';
import { initializeApp } from './services/firebase';
import loadModule from './core/init/init';
import Phio from './domains/phio';
import {
    isLocalHost,
    isPlayground,
    isDev,
    isTestingEnv,
    isStaging,
} from './utils/environmentUtil/environmentUtil';

import firebaseConfigs from './firebaseConfigs';
import * as serviceWorker from './serviceWorker';
import { isAuthStateReady } from './services/auth';

type Environment = 'prod' | 'staging' | 'playground' | 'local';

const cookieYes = Cookies.get('cookieyes-consent');
const loadLogRocket = cookieYes?.includes('analytics:yes');

let env: Environment = 'prod';
let envName = 'localhost';
if (isLocalHost()) {
    env = 'local';
} else if (isDev()) {
    if (isTestingEnv()) {
        envName = 'test';
    }
    if (isPlayground()) {
        envName = 'playground';
    }
    if (isStaging()) {
        envName = 'staging';
    }
    env = 'staging';
    console.log(`SHA: ${process.env.REACT_APP_CURRENT_GIT_SHA}`);
}

// logRocket not working with cookiesYes disabled for further investigation
if (!isLocalHost() && loadLogRocket) {
    LogRocket.init('kxe71y/phio', {
        shouldCaptureIP: false,
        release: process.env.REACT_APP_CURRENT_GIT_SHA,
    });
}

if (env !== 'prod') {
    console.log(`environment: ${envName}`);
}

const APP = initializeApp(firebaseConfigs[env]);
export const FUNCTIONS = getFunctions(APP);
export const UKFUNCTIONS = getFunctions(APP, 'europe-west2');
export const AUFUNCTIONS = getFunctions(APP, 'australia-southeast1');
export const REMOTE_CONFIG = getRemoteConfig(APP);

REMOTE_CONFIG.settings.minimumFetchIntervalMillis = 3600000;

const container = document.getElementById('root');
const root = createRoot(container!);

isAuthStateReady()
    .then(() => loadModule('phio'))
    .then((module) => {
        root.render(<module.default />);
    })
    .catch((e: Error) => {
        console.log('error', e);
        root.render(<Phio />);
    });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
